const siteContent = {
  "seo": {
    "siteName": "CIC",
    "defaultTitle": "CIC |アジア金融犯罪捜査センター |アジア金融犯罪捜査センター",
    "defaultDescription": "CIC (アジア金融犯罪捜査センター) は、国境を越えた金融犯罪捜査と詐欺資金の追跡と回収に重点を置き、多国籍協力ネットワークをカバーし、仮想通貨、投資、デート、その他の事件について専門的な調査と法的支援を提供しています。",
    "ogImage": "https://cicww.com/logo.png?v=3",
    "canonicalBase": "https://cicww.com",
    "tiktokPixelId": "D73NBABC77UCBSL4P06G",
    "defaultOgDescription": "CIC (アジア金融犯罪捜査センター) は、アジアにおける国境を越えた金融犯罪捜査、資産追跡、資金回収に重点を置いています。 24 時間以内に無料でケース評価を提供し、プロセス全体の機密性が保たれます。",
    "logoUrl": "/logo.png?v=3"
  },
  "navLinks": [
    {
      "label": "ホームページ",
      "href": "#hero"
    },
    {
      "label": "CICアジア金融詐欺防止アクションセンターについて",
      "href": "#about"
    },
    {
      "label": "私たちの利点",
      "href": "#advantages"
    },
    {
      "label": "回復プロセス",
      "href": "#process"
    },
    {
      "label": "お客様のレビュー",
      "href": "#testimonials"
    },
    {
      "label": "詐欺の種類",
      "href": "#scam-types"
    },
    {
      "label": "グローバルネットワーク",
      "href": "#network"
    },
    {
      "label": "お問い合わせ",
      "href": "/contact"
    }
  ],
  "brandName": "CIC",
  "hero": {
    "badge": "アジア金融犯罪捜査センター",
    "title": "アジア金融犯罪捜査センター",
    "subtitle": "CIC ・国境を越えた金融犯罪捜査と資金回収",
    "description": "私たちは正義と真実に対する当初の願望を常に守り、すべてのオンライン詐欺犯罪者を取り締まり、無数の人々の個人情報のセキュリティを保護し、すべての被害者が苦労して稼いだお金を取り戻すことに全力で取り組んでいます。この本来の意図と責任により、私たちは常に最新の詐欺手法を理解し、法務/財務/インターネットの専門スキルをすべて学び、豊富な国際経験と専門パートナーを蓄積することに駆り立てられています...インターネット セキュリティはよそよそしいものではなく、必要としているすべての人に役立つものであるべきです。",
    "quote": "「フィッシング詐欺に遭遇した後、CIC アジア金融詐欺対策センターに連絡しました。資金追跡は 48 時間以内に開始され、最終的に損失は回復しました。",
    "quoteAuthor": "— 山本様｜日本 - 8,612万円を回収",
    "primaryCta": "シニアパートナー評価の予約をする →",
    "secondaryCta": "当社のサービスについて詳しく見る",
    "mediaMentions": [
      "SCMP",
      "Reuters",
      "Bloomberg",
      "TVBS"
    ],
    "trustBadges": [
      "初回無料相談",
      "プロセス全体にわたる厳格な機密保持",
      "失敗した場合は料金はかかりません"
    ],
    "locations": [
      "シンガポール",
      "台湾",
      "香港",
      "東京"
    ],
    "seoH1": "アジア金融犯罪捜査センター | CIC |国境を越えた金融犯罪捜査と資金回収",
    "coverVideo": ""
  },
  "about": {
    "coverImage": "/images/about-cover.jpg",
    "seoH1": "CIC アジア金融詐欺防止アクションセンターについて | CIC",
    "browserTitle": "CICアジア金融詐欺対策センターのご紹介 |国際不正防止法務チーム CIC",
    "browserDescription": "CIC は、多くの国からサイバー セキュリティの専門家、金融弁護士、調査活動の専門家を結集し、オンライン資金詐欺事件の調査、追跡、位置づけ、法的支援に重点を置き、被害者の損失の回復に取り組んでいます。",
    "title": "CICアジア金融詐欺防止アクションセンターについて",
    "paragraphs": [
      "長年にわたり、当社は常に「プロ意識、厳格さ、誠実さ」という核となる価値観を堅持し、社会正義と信頼の維持に努めてきました。数え切れないほどの実際の成功事例は、正義に対する当社の確固たる決意を裏付けるだけでなく、実務対応においても優れた成果を上げています。個人の正当な権利と利益を保護する場合でも、企業が包括的なリスク防止システムに注意を払うように支援する場合でも、私たちは常に最も堅実な道を歩みます。",
      "設立以来、当社は世界中の 50 以上の国と地域の被害者が騙された資金を取り戻すのを支援してきました。私たちは、すべてのクライアントの背後に正義を求めるストーリーがあることを知っているため、最もプロフェッショナルかつ効率的な方法で各クライアントにサービスを提供することに尽力しています。",
      "当社のサービスは、仮想通貨詐欺、投資詐欺、フィッシング詐欺、ロマンス詐欺など、さまざまな詐欺事件の資金回収をカバーします。どんなに複雑な事件であっても、お客様の正当な権利利益を守るために最善を尽くします。"
    ],
    "stats": {
      "response": "24 時間対応",
      "countries": "対象国",
      "confidentiality": "機密保持の誓約",
      "lawyers": "専門弁護士"
    },
    "cta": "詳細はこちら",
    "missionPageTitle": "私たちの使命",
    "statNumbers": {
      "countriesTarget": 50,
      "lawyersTarget": 15
    },
    "coreValues": {
      "title": "コアの価値観",
      "subtitle": "これらの価値観は、私たちが行うすべての決定と行動の指針となります",
      "items": [
        {
          "title": "プロフェッショナルファースト",
          "desc": "私たちは最高の専門基準を遵守し、あらゆるクライアントに優れた法的サービスを提供します。"
        },
        {
          "title": "国際的な視点",
          "desc": "国境を越えた専門チームが、複雑な国際詐欺事件を処理します。"
        },
        {
          "title": "お客様第一",
          "desc": "お客様の利益は常に私たちの仕事の中心であり、私たちは心を込めてサービスを提供します。"
        },
        {
          "title": "誠実さと透明性",
          "desc": "透明性のあるコミュニケーションを維持し、長期的な信頼関係を構築します。"
        }
      ]
    },
    "professionalIntro": {
      "title": "プロフェッショナルチーム",
      "paragraphs": [
        "当社の中核チームは、平均 10 年以上の経験を持ち、さまざまな法域の上級弁護士、金融アナリスト、デジタル フォレンジックの専門家で構成されており、コモンローおよび民法制度に基づく資産凍結、証拠開示、国境を越えた執行経路に精通しています。",
        "仮想資産とオンチェーン追跡の分野では、チームは多数のコンプライアンス技術サプライヤーやブロックチェーン分析機関との連携を維持しており、コンプライアンスを前提に電子証拠を迅速に修正し、資金の流れを整理し、海外の法執行機関や金融機関と接続することができます。",
        "私たちは、クライアントがいつでも進捗状況を通知され、重要な局面で明確で実行可能な法的アドバイスを受けられるように、事件の分類と段階報告メカニズムを遵守しています。"
      ],
      "imageUrl": "/images/about-cover.jpg"
    },
    "consultBanner": {
      "title": "助けが必要ですか?",
      "subtitle": "無料のケース評価と専門的なアドバイスについては、今すぐお問い合わせください",
      "cta": "無料相談",
      "ctaHref": "/contact"
    },
    "eeatBlocks": {
      "whoTitle": "私たちとは",
      "whoParagraphs": [
        "Asian Financial Crime Investigation Center (CIC) は、国境を越えた詐欺資金の回収に重点を置いた国際法律事務所で、36 以上の国内法執行ネットワークと 14 以上の管轄区域の協力メカニズムをカバーしています。",
        "私たちのチームは、仮想通貨詐欺、投資詐欺、オンラインデート詐欺、その他の事件の処理を専門とする、現役弁護士、認定金融調査員、ブロックチェーン法医学専門家で構成されています。"
      ],
      "howTitle": "私たちの働き方",
      "howBullets": [
        "失敗した場合は料金はかかりません - 資金を回収した後にのみサービス料金を請求します",
        "無料の事前ケース評価は 24 時間以内に完了します",
        "プロセス全体は機密として扱われ、データ保護規制が厳格に遵守されます。",
        "36 か国以上の法執行機関との正式な協力メカニズムを確立する"
      ],
      "complianceTitle": "資格とコンプライアンス",
      "complianceParagraphs": [
        "アジア金融犯罪捜査センターは、複数の管轄区域で専門資格を保有しており、現地の法律、規制、弁護士の職業倫理基準を厳格に遵守しています。すべての事件は資格のある弁護士が担当します。"
      ],
      "complianceNote": "実施機関の具体的な名前、登録番号、規制当局の情報は、正式な委託プロセス中に、該当する管轄区域に従って開示および確認される場合があります。",
      "contactTitle": "お問い合わせ",
      "contactBody": "詐欺に遭ったと思われる場合は、すぐにご連絡ください。当社のチームは 24 時間以内に無料の初期評価を完了します。",
      "contactCtaLabel": "無料のケース提出",
      "contactCtaHref": "/contact"
    }
  },
  "advantages": {
    "seoH1": "私たちの利点 |国境を越えた詐欺資金回収と専門法務チーム | CICアジア金融詐欺防止活動センター",
    "servicesSeoH1": "不正資金回収サービス |暗号通貨、投資、デート詐欺の法的支援 | CICアジア金融詐欺防止活動センター",
    "browserTitle": "チームアドバンテージと国境を越えた回復力 |不正資金回収法務サービス | CICアジア金融詐欺対策アクションセンター |無料相談",
    "browserDescription": "CIC アジア金融詐欺対策アクション センター チームには、多くの国の弁護士と捜査リソースが含まれており、国境を越えた詐欺資金の回収と資産保全に重点を置き、証拠チェーンの構築、チェーン上の追跡、交渉の実行において成熟した方法論を形成しています。当社の中核的な強みと協力ネットワークを理解し、無料相談の予約を歓迎し、案件の実現可能性と段階計画を取得し、プロセス全体の機密性を保ちます。ノーウィン、ノーフィーのモデルにより、意思決定コストが削減され、多言語コミュニケーションと緊急対応がサポートされます。すぐにご連絡いただき、独自の回復評価と次のアクション リストを開始してください。",
    "servicesBrowserTitle": "不正行為回復サービス |仮想通貨、投資、出会い系詐欺 | CICアジア金融詐欺防止活動センター",
    "servicesBrowserDescription": "CIC アジア金融詐欺対策オペレーション センターは、仮想通貨詐欺、投資詐欺、オンライン出会い系詐欺、オンライン ショッピング詐欺、フィッシング詐欺、国境を越えた詐欺など、包括的な詐欺資金回収サービスを提供しています。失敗しても料金はかからず、すぐに無料で評価されます。当社は、オンチェーン追跡、財務調査、国境を越えた法的戦略を組み合わせて、多言語コミュニケーションをサポートします。オンラインで情報を送信するか、電話で予約してください。24 時間以内に事前フィードバックを提供します。すぐに相談して、1対1のケース評価と回復経路の計画を取得してください。プロセス全体を通じて専門のコンサルタントが同行します。",
    "title": "私たちの利点",
    "subtitle": "プロフェッショナル、効率的、秘密厳守 - これがすべてのお客様に対する当社の約束です",
    "pageIntro": "長年の実務経験と専門的な協力ネットワークにより、私たちはクライアントに信頼できる国境を越えた資本回収と法的サービスを提供します。",
    "items": [
      {
        "stat": 15,
        "suffix": "+",
        "statLabel": "年の専門的経験",
        "title": "プロ意識",
        "desc": "私たちのチームは、国境を越えた資金追跡と法的訴訟において 15 年以上の専門的経験を持つ上級弁護士、金融専門家、調査員で構成されています。当社は、各国の法制度や金融監督政策を深く理解しており、お客様に最も専門的な法的アドバイスや再生計画を提供することができます。",
        "bullets": [
          "国境を越えた損失回収における 15 年以上の実務経験",
          "多国籍の実務と協力の弁護士リソースの統合",
          "主要な法域における金融監督とコンプライアンスの重要なポイントに精通している",
          "オンチェーン追跡機能とデジタルフォレンジック機能を完全装備"
        ]
      },
      {
        "stat": 93,
        "suffix": "%",
        "statLabel": "成功率",
        "title": "高い成功率",
        "desc": "高度な資金追跡技術と豊富な事例経験により、当社の資金回収成功率は 93% と高くなります。仮想通貨詐欺、投資詐欺、その他の金融詐欺であっても、資金の流れを迅速に特定し、効果的な法的措置を講じます。",
        "bullets": [
          "一般的なシナリオでの高い資金回収成功率",
          "複数のタイプのケースで、データに基づいて段階的な目標を提供できます",
          "国境を越えた事件、法執行機関、協力チャンネルのコラボレーション",
          "計画は透明性があり、段階的に見直すことができます"
        ]
      },
      {
        "stat": 100,
        "suffix": "%",
        "statLabel": "情報の機密保持",
        "title": "機密厳守",
        "desc": "私たちはお客様のプライバシーの重要性を十分に認識しており、職業倫理を厳格に遵守します。すべてのケース情報は銀行レベルの暗号化によって保護されており、クライアントの許可なしに第三者に開示されることはありません。お客様の情報のセキュリティは当社の第一の取り組みです。",
        "bullets": [
          "ケースデータの階層ストレージとアクセス制御",
          "守秘義務と作業プロセスの制約に署名する",
          "外部への開示は顧客による明示的な許可が必要です",
          "物資の輸送には安全な通信チャネルの使用を優先する"
        ]
      }
    ],
    "moreTitle": "その他の利点",
    "moreSubtitle": "あらゆる範囲のサービス保証を提供します",
    "moreItems": [
      {
        "title": "素早い対応",
        "desc": "お問い合わせへの回答は営業日を優先し、保存と交渉の時間枠を把握するために、通常 24 時間以内に事前評価のフィードバックを完了してください。"
      },
      {
        "title": "国際ネットワーク",
        "desc": "国境を越えた事件の進行効率を向上させるために、世界中の主要な管轄区域および協力機関とのコミュニケーション チャネルを維持します。"
      },
      {
        "title": "完全なフォローアップ",
        "desc": "専任担当者が資料と進行状況を調整し、コンプライアンスの範囲内で主要なノードを同期し、情報の遅れによる不確実性を軽減します。"
      }
    ],
    "statsTitle": "データは語る",
    "statsSubtitle": "規模とコラボレーション ネットワークを活用してあらゆるコミッションをサポート",
    "pageBottomTitle": "プロフェッショナルなサービスを体験してください",
    "pageBottomSubtitle": "国境を越えた詐欺への対処と資金回収をどのように支援できるかについては、今すぐお問い合わせください。",
    "pageBottomCtaText": "無料相談",
    "ctaTitle": "もっと詳しく知りたいですか?",
    "ctaSubtitle": "損失の回復を私たちがどのように支援できるかを学び、今すぐ無料相談を始めてください",
    "ctaPrimary": "メリットの詳細はこちら",
    "ctaSecondary": "今すぐ相談してください"
  },
  "process": {
    "seoH1": "資金回収プロセス | 4 段階の追跡と回復パス | CIC アジア金融詐欺対策アクションセンター CIC",
    "howItWorksSeoH1": "サービスの仕組み |CIC アジア金融詐欺対策センターの 4 段階の資金回収プロセス",
    "title": "資金回収プロセス",
    "subtitle": "シンプル、透明性、効率的なサービスプロセスにより、安心して信頼していただけます",
    "pageIntro": "資料の評価から実行の返却まで、各段階には明確な提供とコミュニケーションのリズムがあるため、進捗を管理できます。",
    "steps": [
      {
        "num": "01",
        "title": "ケースの評価",
        "desc": "事件の詳細を送信した後、当社の専門チームが 24 時間以内にお客様の事件の包括的な評価を実施し、資金回収の可能性と最適な計画を分析します。",
        "bullets": [
          "無料の予備ケースレビュー",
          "復旧パスと実現可能性を評価する",
          "段階的な戦略的提案を作成する",
          "コンプライアンスの範囲内で専門的な意見を表明する"
        ]
      },
      {
        "num": "02",
        "title": "契約書に署名します",
        "desc": "事件の評価に合格した後、両当事者の権利と義務を明確にし、サービスの透明性と専門性を確保するために、お客様と正式な法律サービス契約を締結します。",
        "bullets": [
          "料金とステージ目標は事前に合意されています",
          "権利と義務の明確な列挙",
          "法的書類と認可が完了しました",
          "支払い方法はケースバイケースで交渉可能"
        ]
      },
      {
        "num": "03",
        "title": "実行の追跡",
        "desc": "当社の専門チームは直ちに資金追跡プロセスを開始し、高度なテクノロジーと法的手段を使用して資金の流れを特定し、対応する法的措置を講じます。",
        "bullets": [
          "オンチェーンとオフチェーンの手がかりの共同分析",
          "複数の管轄区域にわたる協力と文書の作成",
          "規制当局およびパートナー機関との連絡",
          "主要ノードは進行状況を同期します"
        ]
      },
      {
        "num": "04",
        "title": "基金の収益",
        "desc": "資金を正常に回収した後、契約に従って資金を返却し、完全な法的文書と回収報告書を提供します。",
        "bullets": [
          "返品の手配とアカウントの調整",
          "ケースクローズの文書とデータのアーカイブ",
          "定期的なレビューとレポートの提供",
          "必要なフォローアップの法的ヒント"
        ]
      }
    ],
    "hint": "あなたのケースが該当するかどうかわかりませんか?当社の専門チームが無料の初期評価を提供します",
    "cta": "今すぐ無料評価を入手してください",
    "timelineTitle": "詳細なタイムライン",
    "timelineSubtitle": "各段階の主な業務を理解する（参考、実際の状況はケースによって異なります）",
    "timelinePhases": [
      {
        "range": "1日目",
        "title": "案件の受付と事前評価",
        "items": [
          "事件情報と証拠資料を収集する",
          "事前の資金の流れ分析と判断",
          "実現可能性と戦略の議論",
          "次の作業計画を立てる"
        ]
      },
      {
        "range": "2 ～ 3 日目",
        "title": "契約締結と正式発足",
        "items": [
          "サービス範囲と段階目標を確認する",
          "プロジェクトコラボレーションチームを結成する",
          "詳細な調査と補足資料を開始する",
          "必要な協力チャネルと接続する"
        ]
      },
      {
        "range": "4 ～ 10 日目",
        "title": "実行フェーズの追跡",
        "items": [
          "継続的な追跡と固定証拠",
          "法的手続きと書類の提出",
          "関係者との調整と連絡",
          "合意された頻度に従って進行状況を同期します"
        ]
      },
      {
        "range": "11 ～ 14 日目",
        "title": "凍結、返品、ケースクローズ",
        "items": [
          "必要に応じて凍結措置の申請や協力をお願いします",
          "合意された手順を完了し、引き渡します",
          "資金の返却と口座の確認",
          "配信レポートとフォローアップの推奨事項"
        ]
      }
    ],
    "processFaqTitle": "よくある質問",
    "processFaqSubtitle": "回復プロセスに関するよくある質問",
    "processFaqItems": [
      {
        "q": "資金を回収するにはどのくらい時間がかかりますか?",
        "a": "サイクルタイムは、事件や管轄区域の状況によって大きく異なり、数週間から数か月の範囲です。複数の管轄区域が関与する事件や、協調的な執行が必要な事件の場合は、時間がかかることがよくあります。事前評価中に段階的な予想時間を与え、進捗に応じてノードごとに更新します。"
      },
      {
        "q": "充電規格は何ですか?",
        "a": "「成功なし、手数料なし」など、個々のケースに応じたモデルを採用できます。隠れた料金を避けるために、具体的な料金、ステージ分割、請求ノードは正式な契約書に記載されます。"
      },
      {
        "q": "復旧成功率はどれくらいですか？",
        "a": "成功率は、証拠の完全性、資金の流れ、取引相手、実行環境などの要因によって異なります。歴史的に、チームは実用的な手がかりのある事件で多くの肯定的な結果を達成してきました。初期評価では、空約束ではなく実際的な判断を下すために資料を組み合わせます。"
      }
    ],
    "pageBottomTitle": "資金の回収を始める準備はできていますか?",
    "pageBottomSubtitle": "今すぐ無料のケース評価を受けて、頼りになる手段と操作性を理解してください。",
    "pageBottomCtaText": "今すぐ無料評価を入手してください"
  },
  "team": {
    "seoH1": "専門チーム |CIC アジア金融詐欺対策センター グローバル",
    "browserTitle": "専門チームと法律顧問 |国境を越えた詐欺資金の回収 | CICアジア金融詐欺防止活動センター",
    "browserDescription": "CIC アジア金融詐欺対策アクション センターのコア チーム メンバーの背景を理解します。国境を越えた紛争解決、金融調査、デジタル フォレンジックなどです。この Web サイトに表示される情報は一般的な紹介です。特定の専門資格および監督情報は、正式な委託プロセス中に確認できます。無料相談のご予約をお待ちしております。",
    "eeatFootnote": "注: ウェブサイトに表示される名前と履歴書は、チームの専門的な構成を示すために使用されます。特定の専門資格、監督登録、および開示の範囲は管轄区域および認可によって異なります。正式な委託前に、ご要望に応じてコンプライアンス要件に沿った説明と確認方法を提供します。",
    "title": "CICアジア金融詐欺対策アクションセンター",
    "subtitle": "経験豊富で専門的な法律エリート",
    "pageIntro": "アジア金融犯罪捜査センター チームは、現役の弁護士、金融調査員、ブロックチェーン法医学の専門家で構成され、36 か国以上で詐欺資金回収のための法的サービスを提供しています。",
    "lawyerSectionTitle": "弁護士チーム",
    "investigatorSectionTitle": "調査および科学捜査チーム",
    "members": [
      {
        "role": "設立実行委員長",
        "name": "Jamal DeSean Carter",
        "exp": "は、多国籍企業の設立とトップレベルの戦略計画において 20 年以上の経験があります。エンタープライズ ビジネス モデルのゼロから 1 への構築、グローバル資本市場のレイアウト、および上級管理チームのリーダーシップを専門としています。鋭い市場洞察力と優れた意思決定の勇気により、彼は数多くの大規模な国境を越えた合併・買収や革新的な産業変革の推進に成功し、企業の持続可能な発展のためのマクロ基盤の構築に尽力しています。",
        "edu": "不正行為対策業界で 12 年の経験"
      },
      {
        "role": "常務理事",
        "name": "池田 誠一",
        "exp": "は、コーポレート ガバナンスと中核事業開発に深い経験があり、取締役会のマクロ戦略を効率的な実行マトリックスに変換する責任を負います。彼は、組織構造の最適化、リスク管理、部門間のリソース統合に精通しており、データ主導の意思決定を使用して、変化する市場環境において会社が常に安定した事業成長と最適な利益パフォーマンスを維持できるようにしています。",
        "edu": "ケンブリッジ大学法学修士"
      },
      {
        "role": "主任技術調査員",
        "name": "石川 拓也",
        "exp": "彼は国内または国際的な科学技術調査のトップの経歴を持ち、複雑なデジタル環境で証拠チェーンを抽出することに精通しています。さまざまな主要なテクノロジー犯罪、データ漏洩、APT 攻撃の詳細なソース追跡と技術的特定を主導します。最先端の反捜査技術クラッキングに熟達しており、基盤となるコードとネットワーク アーキテクチャを鋭く分析し、司法訴訟や企業の意思決定に非の打ち所のない重要な技術的証拠を提供することができます。",
        "edu": "東京大学法学部"
      },
      {
        "role": "国境を越えた金融資産調査の専門家",
        "name": "白石 直美",
        "exp": "グローバル金融システム、海外のオフショア構造、複雑な信託ネットワークの資産追跡と徹底した調査を専門としています。国際的に認められたアンチマネーロンダリングスペシャリスト（CAMS）または関連する法医学会計資格を保有していること。彼は、管轄区域を越えた迷路の中で隠された資産や違法な資本の流れを正確に特定し、法的手段を支援することに長けています。彼は、国境を越えた法執行機関と協力して事件を処理する豊富な経験を持っています。",
        "edu": "シンガポール国立大学法学博士"
      },
      {
        "role": "金融詐欺対策およびデジタルフォレンジックの専門家",
        "name": "高橋幸雄",
        "exp": "は、10 年以上にわたり、国境を越えた金融犯罪捜査、デジタル資産回復、オンチェーンフォレンジックの分野に深く携わってきました。複雑なマネーロンダリングネットワークの解体、仮想資産の流れの追跡、国際的な資産差し押さえ戦略を専門としています。彼は、新しいタイプの国境を越えたサイバー詐欺（高度情報投資局、分散型金融 DeFi の抜け穴マネーロンダリング、ダークウェブ資本チェーンを含む）に対する複数の資産回復作戦を指揮してきました。 「オンチェーンインテリジェンス」と「国際私法判決」の統合が得意で、富裕層の個人や企業に対する正確な資本フロー監査と資産保全ソリューションの提供に特化しています。",
        "edu": "コロンビア大学法学修士（米国）",
        "bio": "",
        "imageUrl": "https://cicworldwide.com/api/media/uploads/1784794899910-22e8e3bf1c30.jpg"
      },
      {
        "role": "暗号通貨ファンド追跡専門家",
        "name": "木村 尚之",
        "exp": "ブロックチェーンの生態と分散型金融 (DeFi) のフォレンジック調査に焦点を当てています。オンチェーンデータ分析ツール（Chainaracy、Ellipticなど）の使用に熟達しており、クロスチェーントラッキング、ミキサーパスクラッキング、ウォレット相関分析を専門としています。多くの主要な取引所ハッキング事件や暗号通貨詐欺事件でデジタル資産の回復を支援し、匿名取引を明確な法医学的証拠に変えることに成功",
        "edu": "マサチューセッツ工科大学 コンピューターサイエンス専攻",
        "imageUrl": "https://cicworldwide.com/api/media/uploads/1781164802350-d92220fd6465.jpg"
      },
      {
        "role": "インターネット犯罪捜査の専門家",
        "name": "Li Zhiwei",
        "exp": "は、ネットワーク セキュリティと犯罪防止の最前線で長年の実務経験を持っています。インターネット詐欺、ランサムウェア攻撃、ダークウェブでの違法取引、ソーシャル エンジニアリングの防止と調査を専門としています。ハッカーの行動分析と脅威インテリジェンスの統合を専門としており、攻撃被害を即座に阻止し、企業や政府機関による防衛システムの再構築を支援し、犯罪者を裁く",
        "edu": "香港城市大学法学修士",
        "imageUrl": "https://cicworldwide.com/api/media/uploads/1784794905809-b4f1a3877e2e.jpg"
      }
    ]
  },
  "testimonials": {
    "seoH1": "お客様の声 |検証済み資金回収委託フィードバック | CICアジア金融詐欺防止活動センター",
    "casesSeoH1": "成功事例 |実際の詐欺被害回復事例のまとめ | CICアジア金融詐欺防止活動センター",
    "title": "お客様のレビュー",
    "subtitle": "お客様の声を聞いてください - 実際の成功事例、実際のお客様からのフィードバック",
    "pageIntro": "以下は、いくつかの委託事例の概要です。具体的な結果は、証拠、管轄区域、実行環境によって異なります。最初のコミュニケーション中に、情報を組み合わせて実用的な評価を提供します。",
    "verifiedLabel": "確認済みのお客様",
    "caseStudiesTitle": "成功事例分析",
    "caseStudiesSubtitle": "お客様の資金回収とリスク解決をどのように支援するかを詳しくご覧ください",
    "caseStudies": [
      {
        "title": "国境を越えた複雑な暗号資産事件",
        "description": "海外で準拠していると主張した顧客が異常な引き出しを経験し、バックエンドとの接続が失われた取引プラットフォーム。チームは、オンチェーン分析と複数の管轄区域にまたがる保存パスを組み合わせて、コンプライアンスの枠組み内での凍結と交渉を促進し、その後の返品の条件を作成します。",
        "tags": [
          "オンチェーン追跡",
          "国境を越えたコラボレーション",
          "交換紛争"
        ]
      },
      {
        "title": "複数被害投資詐欺の共同処理",
        "description": "同様の組織構造による一連の投資詐欺事件に対し、複数の顧客と連携して証拠基準や請求経路を統一し、法的手続きや資産手がかりを通じて並行して推進し、執行範囲の向上を図りました。",
        "tags": [
          "集団戦略",
          "アセットリード",
          "プログラムの並列性"
        ]
      },
      {
        "title": "社会的に引き起こされた迅速な対応",
        "description": "委託を受けた後は、チャット、送金、口座の流れの修正を優先し、資金の流れが完全に分散する前に緊急対策窓口の分析とドッキングを完了し、損失拡大のリスクを軽減するよう努めます。",
        "tags": [
          "素早い対応",
          "証拠が修正されました",
          "早急な検討と判断"
        ]
      }
    ],
    "pageBottomTitle": "あなたも次の成功者になれる",
    "pageBottomSubtitle": "情報を送信していただいた後は、コンプライアンスの範囲内でできるだけ早く評価とフィードバックを手配します。",
    "pageBottomCtaText": "無料相談",
    "items": [
      {
        "type": "仮想通貨詐欺",
        "quote": "仮想通貨投資で 5,806 万円をだまし取られ、ほとんどすべての貯蓄を失いかけました。CIC の専門的なサービスを通じて、すべての資金を無事に回収することができました。チームは非常にプロフェッショナルで、全過程を通じて安心でき、満足のいく対応でした。",
        "name": "石井様",
        "location": "日本",
        "timeline": "20日以内に回収",
        "date": "2025 年 12 月 18 日",
        "amount": 58060000,
        "amountText": "5,806 万円",
        "layout": "コンパクト",
        "imageUrl": "/images/testimonials/zhang.jpg"
      },
      {
        "type": "投資詐欺",
        "quote": "投資詐欺に遭った後、資金を取り戻す希望をほとんど失っていました。しかし、CIC の技術チームは専門的な能力を示し、すべてが可能であることを証明してくれました。損失の回復を助けてくれただけでなく、今後どのように詐欺を避けるべきかも教えてくれました。",
        "name": "井上様",
        "location": "日本",
        "timeline": "15日以内に回収",
        "date": "2026 年 2 月 26 日",
        "amount": 19210000,
        "amountText": "1,921 万円",
        "layout": "コンパクト",
        "imageUrl": "/images/testimonials/inoue.jpg"
      },
      {
        "type": "ビジネス詐欺",
        "quote": "企業経営者として、ビジネス詐欺により巨額の資金を失いました。CIC の技術チームは卓越した専門能力と豊富な国際経験を示し、最終的に大部分の資金回収を支援してくれました。彼らのサービスを強くおすすめします。",
        "name": "李様",
        "location": "シンガポール",
        "timeline": "35日以内に回収",
        "date": "2026 年 3 月 8 日",
        "amount": 1250000,
        "amountText": "1,250,000 米ドル",
        "imageUrl": "/images/testimonials/li.jpg"
      },
      {
        "type": "フィッシング詐欺",
        "quote": "フィッシング詐欺に遭った後、CIC に連絡しました。対応は非常に迅速で、資金は 48 時間以内に追跡可能になりました。全体のプロセスは複雑でしたが、常に明確で透明性のあるコミュニケーションを保ち、最終的に損失を取り戻すことに成功しました。",
        "name": "山本様",
        "location": "日本",
        "timeline": "10日以内に回収",
        "date": "2026 年 4 月 27 日",
        "amount": 86120000,
        "amountText": "8,612万円",
        "imageUrl": "/images/testimonials/chen.jpg"
      },
      {
        "type": "暗号通貨詐欺",
        "quote": "投資家として、暗号通貨詐欺により 32 万米ドルを失いました。CIC の技術チームは、優れた国境を越えた追跡能力を示してくれました。複数の国の法執行機関と連携し、最終的に資金回収を支援してくれました。全体のプロセスは非常にプロフェッショナルで効率的であり、彼らを深く信頼しています。",
        "name": "ラマン様",
        "location": "マレーシア",
        "timeline": "20日以内に回収",
        "date": "2026 年 5 月 10 日",
        "amount": 320000,
        "amountText": "320,000 米ドル",
        "imageUrl": "/images/testimonials/malaysia.jpg"
      },
      {
        "type": "外国為替詐欺",
        "quote": "外国為替取引プラットフォームに投資した後、資金を出金できないことに気づきました。CIC アジア金融詐欺対策アクションセンターに連絡したところ、迅速に行動し、国際的な追跡ルートを通じて詐欺プラットフォームの口座凍結に成功しました。2 週間後、損失を無事に回収することができました。彼らの専門能力と効率に心から感謝しています。",
        "name": "ジェームズ様",
        "location": "オーストラリア",
        "timeline": "35日以内に回収",
        "date": "2026 年 6 月 23 日",
        "amount": 795000,
        "amountText": "795,000 米ドル",
        "imageUrl": "/images/testimonials/australia.jpg"
      }
    ],
    "ctaTitle": "成功事例をもっと知りたいですか?",
    "ctaSubtitle": "クライアントの資産回復をどのように支援したかという実際のストーリーをご覧ください。",
    "ctaPrimary": "レビューをもっと見る",
    "ctaSecondary": "今すぐ相談してください"
  },
  "network": {
    "seoH1": "グローバルサービスネットワーク | CIC アジア金融詐欺対策アクション センターは 36 か国以上をカバーし、複数の管轄区域にわたる協力を行っています。",
    "regionDetailSeoH1Template": "{regionName} 不正資金回収と国境を越えた資産追跡 | CICアジア金融詐欺防止活動センター",
    "title": "グローバルサービスネットワーク",
    "subtitle": "シンガポールに本社を置き、世界中の主要な金融および法務センターに拠点を置いています",
    "regionPageTitleSuffix": "サービスネットワーク",
    "regionPageIntroTemplate": "{brandName} は、{regionName} に成熟した国境を越えた協力ネットワークを持っており、投資詐欺、仮想通貨詐欺、フィッシング詐欺、その他の資金回収事件を処理できます。",
    "regionCoverageTitle": "都市をカバー",
    "regionRelatedScamTitle": "関連する詐欺の種類",
    "regionContactTemplate": "迅速なケース評価については、{phone} または {email} までご連絡ください。",
    "regionBackHomeText": "ホームページに戻る",
    "globalStats": [
      {
        "value": 53,
        "suffix": "+",
        "label": "対象国"
      },
      {
        "value": 21,
        "suffix": "+",
        "label": "法執行機関への協力"
      },
      {
        "value": 538,
        "suffix": "+",
        "label": "ケース・オブ・ザ・イヤー"
      },
      {
        "value": 37,
        "suffix": "+",
        "label": "国際弁護士"
      }
    ],
    "regions": [
      {
        "slug": "apac",
        "name": "東アジア",
        "cities": [
          "シンガポール",
          "香港",
          "東京",
          "シドニー",
          "バンコク",
          "クアラルンプール"
        ],
        "count": 18
      },
      {
        "slug": "greater-china",
        "name": "中華圏",
        "cities": [
          "上海",
          "北京",
          "深セン",
          "台北"
        ],
        "count": 8
      },
      {
        "slug": "europe",
        "name": "ヨーロッパ",
        "cities": [
          "ロンドン",
          "フランクフルト",
          "パリ",
          "チューリッヒ"
        ],
        "count": 15
      },
      {
        "slug": "americas",
        "name": "アメリカ",
        "cities": [
          "ニューヨーク",
          "ロサンゼルス",
          "トロント"
        ],
        "count": 12
      },
      {
        "slug": "africa-middle-east",
        "name": "中東",
        "cities": [
          "ドバイ"
        ],
        "count": 5
      }
    ],
    "regionHighlights": [
      {
        "count": 18,
        "label": "アジア太平洋",
        "slug": "apac"
      },
      {
        "count": 15,
        "label": "ヨーロッパ",
        "slug": "europe"
      },
      {
        "count": 12,
        "label": "アメリカ",
        "slug": "americas"
      },
      {
        "count": 5,
        "label": "アフリカ 中東",
        "slug": "africa-middle-east"
      }
    ],
    "networkPageTagline": "4 大陸にまたがり、50 か国以上をカバーする専門的な法律サービス ネットワーク",
    "officesHeading": "本社",
    "officesSubheading": "世界6中核都市でワンストップの法律サービスを提供",
    "networkAdvantagesHeading": "グローバルネットワークの利点",
    "networkAdvantagesSubheading": "国境を越えたケースに対してシームレスなコラボレーション サポートを提供します",
    "networkAdvantages": [
      {
        "title": "24時間対応",
        "desc": "グローバル タイム ゾーンをカバーしているため、チームはいつでもオンラインで緊急事態に対応できます"
      },
      {
        "title": "地元の法律専門家",
        "desc": "各地域には現地の法律に精通した専門の弁護士がおり、対象を絞った法律サービスを提供しています"
      },
      {
        "title": "統一されたサービス標準",
        "desc": "サービスの一貫性を確保するためのグローバルに統一されたサービス プロセスと品質基準"
      },
      {
        "title": "国境を越えたコラボレーション",
        "desc": "複数の拠点にあるチームがシームレスに連携して、国境を越えたケースを効率的に処理します"
      },
      {
        "title": "国際関係ネットワーク",
        "desc": "各国の法執行機関や規制当局と良好な協力関係を構築する"
      },
      {
        "title": "多言語サービス",
        "desc": "中国語、英語、日本語、韓国語、フランス語、ドイツ語などの多言語サービスをサポート"
      }
    ],
    "networkPartnersHeading": "パートナー ネットワーク",
    "networkPartnersSubheading": "世界の当局と緊密な協力を確立する",
    "networkPartners": [
      {
        "name": "インターポール",
        "category": "法執行機関",
        "logoUrl": "/partners/partner-law-enforcement.svg"
      },
      {
        "name": "金融活動タスクフォース",
        "category": "規制当局",
        "logoUrl": "/partners/partner-regulator.svg"
      },
      {
        "name": "各国の証券監督機関",
        "category": "規制当局",
        "logoUrl": "/partners/partner-regulator-2.svg"
      },
      {
        "name": "世界トップの法律事務所ネットワーク",
        "category": "法的協力",
        "logoUrl": "/partners/partner-legal.svg"
      },
      {
        "name": "ブロックチェーン解析会社",
        "category": "技術協力",
        "logoUrl": "/partners/partner-tech.svg"
      },
      {
        "name": "国際銀行不正防止部",
        "category": "資金協力",
        "logoUrl": "/partners/partner-finance.svg"
      }
    ],
    "networkPageCtaTitle": "どこにいてもお手伝いいたします",
    "networkPageCtaSubtitle": "国境を越えた専門的な法的アドバイスについては、当社のグローバル サービス チームにお問い合わせください。",
    "legendItems": [
      {
        "color": "gold-bg",
        "label": "本社（シンガポール）"
      },
      {
        "color": "bg-foreground/60",
        "label": "地域センター"
      },
      {
        "color": "bg-foreground/30",
        "label": "出張所"
      },
      {
        "color": "bg-foreground/15",
        "label": "協力店"
      }
    ],
    "offices": [
      {
        "city": "香港",
        "country": "中国",
        "imageUrl": "/offices/hong-kong.jpg",
        "address": "中环国际金融中心二期",
        "hours": "月曜日〜金曜日 9:00〜18:00",
        "languages": "中国語 / 英語 / 広東語",
        "tags": [
          "グローバル本社",
          "国境を越えた訴訟",
          "国際仲裁"
        ],
        "regionSlug": "APAC"
      },
      {
        "city": "シンガポール",
        "country": "シンガポール",
        "imageUrl": "/offices/singapore.jpg",
        "address": "滨海湾金融中心",
        "hours": "月曜日から金曜日 9:00-18:00 (SGT)",
        "languages": "英語 / 中国語 / マレー語",
        "tags": [
          "東南アジア事業",
          "暗号通貨の追跡"
        ],
        "regionSlug": "APAC"
      },
      {
        "city": "東京",
        "country": "日本",
        "imageUrl": "/offices/tokyo.jpg",
        "address": "丸之内商务区",
        "hours": "月曜～金曜 9:00～18:00（日本時間）",
        "languages": "日本語 / 中国語 / 英語",
        "tags": [
          "アジア太平洋協力",
          "金融規制に関するコミュニケーション"
        ],
        "regionSlug": "APAC"
      },
      {
        "city": "高雄",
        "country": "台湾、中国",
        "imageUrl": "/offices/kaohsiung.jpg",
        "address": "高雄多功能经贸园区",
        "hours": "月曜～金曜 9:00～18:00",
        "languages": "中国語 / 英語 / 福建語",
        "tags": [
          "アジアパシフィックノード",
          "台湾海峡ビジネス"
        ],
        "regionSlug": "APAC"
      },
      {
        "city": "クアラルンプール",
        "country": "マレーシア",
        "imageUrl": "/offices/kuala-lumpur.jpg",
        "address": "双峰塔KLCC商业中心",
        "hours": "月曜日から金曜日 9:00-18:00 (MYT)",
        "languages": "中国語 / 英語 / マレー語",
        "tags": [
          "マレーシアビジネス",
          "ASEAN連携"
        ],
        "regionSlug": "APAC"
      },
      {
        "city": "ドバイ",
        "country": "アラブ首長国連邦",
        "imageUrl": "/offices/dubai.jpg",
        "address": "迪拜国际金融中心（DIFC）",
        "hours": "月曜日から金曜日 9:00-18:00 (GST)",
        "languages": "英語 / アラビア語 / 中国語",
        "tags": [
          "中東ハブ",
          "国境を越えたセキュリティ"
        ],
        "regionSlug": "アフリカ中東"
      }
    ],
    "cta": "完全なグローバル ネットワークを見る"
  },
  "risk": {
    "title": "リスク警告",
    "subtitle": "一般的な詐欺の手口を理解し、財産の安全を守ります",
    "noticeTitle": "重要なお知らせ",
    "noticeText": "詐欺に遭った場合は、ただちに詐欺師との連絡を一切やめ、証拠（チャット記録、振込伝票、契約書類など）をすべて保存し、できるだけ早く当社までご連絡ください。時は金なり、行動を起こすのが早ければ早いほど、お金を回収できる可能性が高くなります。",
    "warnings": [
      {
        "title": "高収益コミットメント",
        "desc": "「利益の保証」や「高いリターン」を約束する投資プロジェクトには注意してください。すべての合法的な投資にはリスクが伴い、100% の収益を保証できる人はいません。"
      },
      {
        "title": "匿名トランザクション",
        "desc": "不透明で身元を確認できない個人や機関との取引は拒否してください。正式な金融機関は完全な KYC 手続きを行っています。"
      },
      {
        "title": "緊急のプレッシャー",
        "desc": "詐欺師は、緊迫感を醸し出すために「期間限定オファー」や「制限された割り当て」などのフレーズをよく使用します。このような状況では、落ち着いて行動してください。"
      },
      {
        "title": "情報を確認してください",
        "desc": "投資を行う前に、必ず公式ルートを通じて企業の登録情報や法的ライセンスなどをご確認ください。専門の弁護士または財務アドバイザーに相談できます。"
      }
    ],
    "emergencyTitle": "詐欺に遭った場合は、直ちに次の措置を講じてください。",
    "emergencySteps": [
      {
        "num": "1",
        "title": "連絡をやめる",
        "desc": "詐欺師とのすべての通信と取引を直ちに停止してください"
      },
      {
        "num": "2",
        "title": "証拠を保存する",
        "desc": "関連する証拠と文書をすべて収集し、保存します"
      },
      {
        "num": "3",
        "title": "お問い合わせ",
        "desc": "ケース評価のためできるだけ早く専門チームに連絡してください"
      }
    ]
  },
  "scamTypes": {
    "seoH1": "私たちが回復を支援する不正行為の種類 |暗号通貨、投資、出会い系、フィッシング、国境を越えた事件 | CICアジア金融詐欺防止活動センター",
    "title": "よくあるタイプの詐欺",
    "subtitle": "さまざまな詐欺手口を理解し、防止意識を高める",
    "pageEyebrow": "詐欺の防止・財産の保護",
    "pageTitle": "一般的な詐欺タイプの完全な分析",
    "pageSubtitle": "さまざまな詐欺の手口について詳しく学び、防止意識を高め、財産損失のリスクを軽減します。損失を被った場合は、機密保持を前提として利用可能なコンプライアンス救済策および保存パスについて当社にご相談ください。",
    "listSectionTitle": "よくあるタイプの詐欺",
    "listSectionSubtitle": "さまざまな詐欺の手口を理解し、防止意識を高める",
    "warningSectionEyebrow": "警告標識",
    "warningSectionTitle": "警告標識",
    "warningSectionSubtitle": "以下の状況に遭遇した場合は、詐欺が発生している可能性があるので注意してください。",
    "warningSignals": [
      "すぐに支払うか、性急な決断をするよう求めています",
      "は超高リターンを約束し、「ゼロリスク」を強調",
      "は、金融取引を親族や友人に対して機密に保つことを要求しています",
      "感情的な誘拐や人為的な緊迫感の演出",
      "では、異常な支払いチャネルまたは追跡が困難な支払いチャネルの使用が必要です",
      "検証可能な被験者の資格と登録情報を提供できません",
      "ソーシャル ソフトウェア経由でのみ連絡し、実名認証を避けてください",
      "オフラインまたは本人確認可能なインタビュー チャネルを拒否する"
    ],
    "protectionSectionEyebrow": "予防に関する提案",
    "protectionSectionTitle": "自分を守る方法",
    "protectionSectionSubtitle": "以下の原則に従うことで、詐欺に遭う可能性を減らすことができます。",
    "protectionBlocks": [
      {
        "title": "常に警戒してください",
        "intro": "早期撤退、異常に高い利益、過剰な熱中などの「投資機会」には疑ってください。多くの場合、ゆっくりと検証する方が安全です。",
        "bullets": [
          "見知らぬ人が勧める「利益が保証された」プロジェクトを信用しないでください",
          "過度に寛大な条件について「なぜ」をもう 1 つ質問してください",
          "相手方の実体、ライセンス、連絡先情報を確認してください",
          "プレッシャーを受けてその場で送金したり契約書に署名したりすることは避けてください。"
        ]
      },
      {
        "title": "本人確認を行う",
        "intro": "公式の公開チャネルを通じて相手の身元を相互検証します。単一のリンク、スクリーンショット、ソーシャル アカウントだけに依存しないでください。",
        "bullets": [
          "規制当局または企業登録プラットフォームで対象情報を照会します",
          "公式ウェブサイトに掲載されているカスタマーサービスの電話番号に折り返し電話して確認します",
          "検証可能な法的資料および認証資料を要求し、保管する",
          "偽のドメイン名や類似性の高いアプリ/Web ページに注意してください"
        ]
      },
      {
        "title": "情報を保護する",
        "intro": "銀行カード、確認コード、身分証明書の開示を最小限に抑え、詐欺やフィッシングの余地を減らします。",
        "bullets": [
          "強力なパスワードを使用し、定期的に更新してください",
          "SMS 認証コードと支払いパスワードを誰にも開示しないでください",
          "見慣れないリンクをクリックする場合は注意し、ブラウザのアドレス バーでドメイン名を確認してください。",
          "アカウントの変更を定期的に確認し、通知を有効にします"
        ]
      },
      {
        "title": "すぐに助けを求めてください",
        "intro": "異常または転送が見つかった場合は、できるだけ早く証拠を修正し、銀行や専門機関に連絡して時間を確保してください。",
        "bullets": [
          "できるだけ早く口座開設銀行に連絡し、状況を説明し、サポートを申請してください。",
          "チャット、契約、取引、Web ページのスクリーンショットなどの証拠を保存します",
          "必要に応じて警察または規制当局に事件を報告し、証明書を取得します。",
          "国境を越えた訴訟の経験を持つ法務チームに相談できます"
        ]
      }
    ],
    "emergencyBannerTitle": "すでに詐欺に遭ったことがありますか?できるだけ早く行動してください",
    "emergencyBannerSubtitle": "証拠が確定し、専門的な評価が開始されるのが早ければ早いほど、凍結、救済措置、交渉の余地を決定するのに役立ちます。",
    "emergencyBannerCtaText": "すぐに専門チームに相談してください",
    "detailPageTitleSuffix": "資金回収ガイド",
    "detailFeaturesTitle": "一般的な詐欺の特徴",
    "detailRelatedRegionsTitle": "関連する地域サービス",
    "detailContactTemplate": "特定のケースを評価するチームが必要ですか? {email} に直接連絡してください。",
    "detailBackHomeText": "ホームページに戻る",
    "items": [
      {
        "title": "仮想通貨詐欺",
        "seoH1": "仮想通貨詐欺資金回収 |オンチェーン追跡とデジタル資産回復 | CICアジア金融詐欺防止活動センター",
        "range": "$10,000 - $2,000,000",
        "cases": "2,847+",
        "rate": "91%",
        "risk": "高リスク",
        "desc": "偽の仮想通貨取引プラットフォーム、ICO プロジェクト、または投資計画。詐欺師はブロックチェーン技術の複雑さと仮想通貨の匿名性を利用して、被害者をだまして存在しないプロジェクトに投資させたり、取引プラットフォームを操作させたりします。",
        "tags": [
          "偽の交換",
          "ネズミ講",
          "偽 ICO プロジェクト",
          "マイニング詐欺"
        ],
        "imageUrl": "/images/scams/crypto.jpg"
      },
      {
        "title": "投資詐欺",
        "seoH1": "投資詐欺資金回収 |偽の取引プラットフォームと違法な株の推奨 | CICアジア金融詐欺防止活動センター",
        "range": "$5,000 - $1,500,000",
        "cases": "3,521+",
        "rate": "89%",
        "risk": "高リスク",
        "desc": "外国為替取引、ストック オプション、貴金属への投資など、高い収益を約束する偽の投資プロジェクト。詐欺師は多くの場合、偽の利益数値を表示して、被害者にさらに資金を投資するよう誘惑します。",
        "tags": [
          "偽外国為替プラットフォーム",
          "違法な先物取引",
          "偽ファンドプロジェクト",
          "金投資詐欺"
        ],
        "imageUrl": "/images/scams/investment.jpg"
      },
      {
        "title": "恋愛詐欺",
        "seoH1": "オンラインデート詐欺資金回収 |感情的に誘発された異動と国境を越えた回復 | CICアジア金融詐欺防止活動センター",
        "range": "$3,000 - $800,000",
        "cases": "1,893+",
        "rate": "90%",
        "risk": "中リスク",
        "desc": "詐欺師は、ソーシャル メディアや出会い系プラットフォームで成功者を装い、被害者と感情的な関係を築き、さまざまな理由で送金を要求します。このような詐欺には、国境を越えた資金の送金が含まれることがよくあります。",
        "tags": [
          "偽の身分",
          "緊急ヘルプ",
          "投資アドバイス",
          "ギフトリクエスト"
        ],
        "imageUrl": "/images/scams/romance.jpg"
      },
      {
        "title": "オンライン ショッピング詐欺",
        "seoH1": "オンライン ショッピング詐欺の法的支援 |偽電子商取引と支払い後の商品の不達 | CIC アジア金融詐欺防止活動センター",
        "range": "$500 - $50,000",
        "cases": "4,156+",
        "rate": "95%",
        "risk": "低リスク",
        "desc": "偽の電子商取引ウェブサイトやソーシャルメディア広告を通じて存在しない商品を販売したり、支払いを受け取った後に商品を発送しないこと。詐欺師の中には、被害者の支払い情報を盗んで他の犯罪に使用する人もいます。",
        "tags": [
          "偽オンラインストア",
          "虚偽の広告",
          "中古取引詐欺",
          "前払い詐欺"
        ],
        "imageUrl": "/images/scams/shopping.jpg"
      },
      {
        "title": "フィッシング",
        "seoH1": "フィッシング詐欺の回復 |偽の Web サイトとなりすましの顧客サービス | CICアジア金融詐欺対策オペレーションセンター",
        "range": "$1,000 - $300,000",
        "cases": "5,234+",
        "rate": "92%",
        "risk": "中リスク",
        "desc": "銀行、政府機関、または有名企業からの電子メール、テキスト メッセージ、または Web サイトを装い、被害者から個人情報、アカウントのパスワード、または支払い情報を騙し取り、資金を盗みます。",
        "tags": [
          "偽の銀行メール",
          "偽サイト",
          "偽のカスタマー サービスの電話番号",
          "悪意のあるリンク"
        ],
        "imageUrl": "/images/scams/phishing.jpg"
      },
      {
        "title": "国境を越えた詐欺",
        "seoH1": "国境を越えた詐欺の法的回復 |複数の管轄区域にわたる協力と資産保全 | CICアジア金融詐欺防止活動センター",
        "range": "$20,000 - $5,000,000",
        "cases": "1,428+",
        "rate": "89%",
        "risk": "高リスク",
        "desc": "各国の法律の違いや法執行の困難を利用して、国境を越えたさまざまな詐欺活動を実行します。このような事件は追跡が難しく、専門の国際法務チームの支援が必要です。",
        "tags": [
          "偽装海外投資",
          "国際送金詐欺",
          "入国詐欺",
          "海外住宅購入の罠"
        ],
        "imageUrl": "/images/scams/cross-border.jpg"
      }
    ],
    "ctaTitle": "上記のタイプの詐欺に遭遇しましたか?",
    "ctaSubtitle": "どのようなタイプに遭遇しても、当社には損失の回復を支援する専門チームがいます。",
    "ctaPrimary": "詐欺の種類を詳しく見る",
    "ctaSecondary": "すぐに助けを求めてください"
  },
  "faq": {
    "title": "よくある質問",
    "subtitle": "疑問に答えて、安心して信頼してください",
    "items": [
      {
        "q": "騙された資金はどうやって取り戻しましたか?",
        "a": "当社は専門的な資金追跡技術を使用して詐欺された資金の流れを特定し、国際的な法的手段と法執行機関の協力を利用して資金を凍結および回収します。プロセス全体には、証拠収集、法的手続き、資産凍結、資金返還などのステップが含まれます。"
      },
      {
        "q": "資金を回収するにはどのくらい時間がかかりますか?",
        "a": "具体的な時間は事件の複雑さによって異なります。単純な事件は数週間以内に解決される可能性がありますが、国境を越えた複雑な事件は数か月かかる場合があります。初期評価の際に、おおよそのスケジュールを提示させていただきます。"
      },
      {
        "q": "充電基準は何ですか?",
        "a": "私たちは「成功しなければ手数料もかからない」モデルを採用しています。初回相談は無料ですが、資金回収が成功した場合のみ、合意した割合に応じてサービス料が請求されます。具体的な料金については、ご契約前に詳しくご説明させていただきます。"
      },
      {
        "q": "どのような情報を提供する必要がありますか?",
        "a": "通常、取引記録、送金伝票、相手方との通信記録、契約書類などを提供する必要があります。当社チームは、最初のコミュニケーション中に準備が必要な具体的な情報をお知らせします。"
      },
      {
        "q": "詐欺師が海外にいる場合でも、取り戻すことはできますか?",
        "a": "はい。当社は世界50カ国以上に協力ネットワークを持ち、現地の法律事務所や法執行機関と緊密な連携を維持し、国境を越えた債権回収事件を効果的に処理できます。"
      },
      {
        "q": "私の個人情報は機密として扱われますか?",
        "a": "絶対的な機密保持。私たちは弁護士の国際的な職業倫理を厳格に遵守しており、すべての事件情報は銀行レベルの暗号化によって保護されています。あなたの許可なしに第三者に開示されることはありません。"
      }
    ]
  },
  "contact": {
    "seoH1": "CIC アジア金融詐欺防止アクション センターにお問い合わせください |無料相談と事例評価 | CIC",
    "assessmentSeoH1": "無料のケース評価 | 24 時間以内の予備意見 | CICアジア金融詐欺防止活動センター",
    "browserTitle": "無料相談 |ケースの評価は 24 時間以内に完了 | CICアジア金融詐欺防止活動センター",
    "browserDescription": "ケースの詳細を送信してください。CIC アジア金融詐欺対策センター チームが 24 時間以内に無料の予備評価を完了し、資金を回収できるかどうかをお知らせします。不成立の場合でも料金は請求されず、プロセス全体は秘密厳守で処理されます。電話、メール、オンラインフォームでサポートしており、多言語を話すコンサルタントがいつでも対応します。コールバックの予約を取り、不正資金を回収するための特別なプランを取得するには、すぐにご連絡ください。譲渡記録、チャット、契約書、その他の証拠をできるだけ早く提出してください。当社は資産追跡と国境を越えたコラボレーションを支援し、回復手順をカスタマイズできます。今すぐ相談して無料評価を開始してください。",
    "assessmentBrowserTitle": "無料のケース評価 | 24時間事前意見・詐欺資金回収 | CICアジア金融詐欺対策アクションセンター |今すぐ送信",
    "assessmentBrowserDescription": "このページでケース情報と連絡先情報を送信してください。 CIC アジア金融詐欺対策センターは、24 時間以内に無料の事前評価を完了し、回復スペース、必要な証拠、推奨されるパスについて説明します。暗号通貨、投資、出会い系、フィッシング、その他の種類の詐欺をカバーし、失敗した場合でも手数料は請求されず、プロセス全体の機密性は保たれます。オンラインまたは電話ですぐに相談して、1 対 1 のケースマネージャーに連絡し、できるだけ早く証拠を修正し、保存期間を確保するよう努めてください。チームはオンチェーン分析と国境を越えた法的リソースを組み合わせて、無料の評価をすぐに提出します。",
    "title": "資金を回収する準備はできていますか?",
    "subtitle": "相談は無料、失敗した場合は費用はかかりません",
    "pageTitle": "お問い合わせ",
    "pageSubtitle": "以下のフォームにご記入ください。24 時間以内にご連絡いたします。",
    "buttonText": "今すぐ無料相談",
    "buttonHref": "/contact",
    "email": "xuanxuan98961@gmail.com",
    "phone": "+852 55732756 / +852  66382319",
    "address": "1 Raffles Place #31-06 Singapore",
    "formSectionTitle": "問い合わせを送信",
    "floatingConsultCta": "今すぐ相談してください",
    "customerServiceScriptUrl": "",
    "customerServiceKefuCode": "",
    "postSubmitWhatsAppUrl": "https://helpmels.com/zx2mvl1t1",
    "whyUs": {
      "title": "なぜ私たちを選んだのですか?",
      "items": [
        {
          "title": "プロフェッショナルチーム",
          "description": "15 年以上の専門的経験、2000 件以上の成功事例を扱い、資金回収成功率は約 93% (個々の事例と証拠によって異なります)。"
        },
        {
          "title": "世界中でカバー",
          "description": "53 以上の国と地域をカバーする国際チームで、21 以上の法執行機関との事件連携とコミュニケーション チャネルを維持しています。"
        },
        {
          "title": "機密保持の誓約",
          "description": "機密保持契約、銀行レベルのデータ暗号化、階層型ストレージを厳守し、顧客のプライバシーと証拠のセキュリティを最大限に高めます。"
        },
        {
          "title": "素早い対応",
          "description": "24 時間以内に事件の予備評価を完了し、資金の回収と保全にかかる時間枠を把握するのに役立ちます。"
        },
        {
          "title": "透明性のある料金",
          "description": "隠れた料金はありません。 「ノー成功・手数料無料」の応相談モデルを採用しており、料金や条件については委託前に事前にご説明させていただきますので、安心してご判断いただけます。"
        }
      ]
    },
    "contactFaqTitle": "よくある質問",
    "contactFaqSubtitle": "コンサルティングサービスに関するよくある質問",
    "contactFaqItems": [
      {
        "q": "相談サービスは無料ですか？",
        "a": "はい、無料の初期ケース評価を提供しています。このページのフォーム、電話、電子メールを通じてご連絡いただければ、24 時間以内にお客様のケースの予備分析を実施し、回復の可能性と一般的な道筋をお知らせします。"
      },
      {
        "q": "どのような情報を準備する必要がありますか?",
        "a": "評価を容易にするために、詐欺プロセスの詳細な説明、振込記録と銀行取引明細書、チャット記録と電子メール、相手方から提供された情報 (契約書、Web サイト、スクリーンショットなど)、および所有するその他の証拠を準備することをお勧めします。"
      },
      {
        "q": "相談後、すぐに契約しなければなりませんか？",
        "a": "必要ありません。事前評価後、分析レポートとオプションのサービスプランをご提供いたします。それらを十分に比較・検討した上で、正式に当社に事件処理を委託するかどうかをご判断ください。"
      },
      {
        "q": "私の情報は機密として扱われますか?",
        "a": "絶対的な機密保持。私たちは弁護士の職業倫理と国際的なプライバシー保護基準を厳格に遵守します。お客様の情報は、事件の処理と連絡のためにのみ使用され、許可なく第三者に開示されることはありません。"
      }
    ]
  },
  "footer": {
    "copyright": "© 2026 CIC · アジア金融犯罪捜査センター。無断転載を禁じます。",
    "links": [
      "プライバシー ポリシー",
      "利用規約",
      "お問い合わせ"
    ],
    "blurb": "CIC Asia Anti-Financial Fraud Action Center は、世界中の顧客による詐欺資金の回収と顧客の正当な権利と利益の保護を支援することに特化した専門的な国際的な反金融法サービス組織です。当事務所は、厳格な専門能力と国境を越えた協力ネットワークを活用して、各クライアントに信頼できる法的サポートを提供します。",
    "quickLinksHeading": "クイックリンク",
    "quickLinksLeft": [
      {
        "label": "ホームページ",
        "href": "/"
      },
      {
        "label": "私たちの利点",
        "href": "/advantages"
      },
      {
        "label": "カスタマーレビュー",
        "href": "/testimonials"
      },
      {
        "label": "グローバルネットワーク",
        "href": "/global-network"
      }
    ],
    "quickLinksRight": [
      {
        "label": "CICについて",
        "href": "/about"
      },
      {
        "label": "プロフェッショナルチーム",
        "href": "/team"
      },
      {
        "label": "回復プロセス",
        "href": "/process"
      },
      {
        "label": "詐欺の種類",
        "href": "/scam-types"
      },
      {
        "label": "お問い合わせ",
        "href": "/contact"
      }
    ],
    "serviceHeading": "サービス範囲",
    "networkHeading": "グローバルネットワーク",
    "networkLinks": [
      {
        "label": "日本本社",
        "href": "/global-network"
      },
      {
        "label": "香港事務所",
        "href": "/global-network"
      },
      {
        "label": "シンガポール支社",
        "href": "/global-network"
      },
      {
        "label": "ロンドン支社",
        "href": "/global-network"
      }
    ]
  },
  "floatingConsult": {
    "href": "https://cicworldwide.com/contact",
    "caption": "詳細はお問い合わせください",
    "logoUrl": ""
  },
  "legal": {
    "privacy": {
      "browserTitle": "プライバシー ポリシー | CIC アジア金融詐欺アクションセンター",
      "browserDescription": "CIC アジア金融詐欺対策アクション センターが、Web サイトや相談チャネルを通じて送信された個人情報、およびお客様の権利や連絡先情報をどのように収集、使用、保護するかをご覧ください。",
      "h1": "プライバシー ポリシー | CICアジア金融詐欺防止活動センター",
      "subtitle": "この声明は、お客様がこの Web サイト、オンライン フォーム、電子メール、または電話を通じて当社に情報を提供する場合に適用されます。",
      "lastUpdatedNote": "最終更新日: 2026 年 3 月 28 日",
      "paragraphs": [],
      "sections": [
        {
          "heading": "収集する情報",
          "body": "当社は、事件の評価と法的サービスの目的で、お客様から提供された事件情報、連絡先情報、関連文書を収集します。"
        },
        {
          "heading": "情報の利用方法",
          "body": "あなたの情報は、事件の処理、法的手続き、およびあなたとの連絡にのみ使用され、販売または商業マーケティングに使用されることはありません。"
        },
        {
          "heading": "情報保護",
          "body": "当社では、お客様の個人情報を保護するために業界標準の暗号化とセキュリティ対策を使用しています。すべての事件情報は極秘に扱われます。"
        },
        {
          "heading": "お問い合わせ",
          "body": "プライバシー関連のご質問がある場合は、公式ウェブサイトのお問い合わせページからお問い合わせください。"
        }
      ]
    },
    "disclaimer": {
      "browserTitle": "免責事項 | CICアジア金融詐欺防止活動センター",
      "browserDescription": "CIC アジア金融詐欺対策センターの Web サイトで一般的な法的免責事項をお読みください。この Web サイトの情報は、正式な法的アドバイスを構成するものではありません。個々の事件の結果は証拠と管轄によって異なります。書面による契約書および弁護士の意見を参照してください。",
      "h1": "免責事項 | CICアジア金融詐欺防止活動センター",
      "subtitle": "委託する前によくお読みください。ご不明な点がございましたら、公式チャネルを通じてご相談ください。",
      "lastUpdatedNote": "最終更新日: 2026 年 3 月 28 日",
      "paragraphs": [],
      "sections": [
        {
          "heading": "法務報告書",
          "body": "この Web サイトの内容は参照のみを目的としており、正式な法的アドバイスを構成するものではありません。特定の事件に関する法的アドバイスは、事件の完全な事実を理解した上で、資格のある弁護士によって提供されなければなりません。"
        },
        {
          "heading": "結果は保証されません",
          "body": "各事件の状況は異なり、過去の事件の結果は将来の事件の結果を保証するものではありません。それぞれのお客様にとって最良の結果が得られるよう努めてまいります。"
        },
        {
          "heading": "サードパーティのリンク",
          "body": "この Web サイトにはサードパーティの Web サイトへのリンクが含まれている場合がありますが、当社はサードパーティのコンテンツについては責任を負いません。"
        }
      ]
    }
  },
  "layout": {
    "homepageSections": [
      {
        "id": "hero",
        "label": "スクロールせずに見えるバナーの上",
        "enabled": true
      },
      {
        "id": "promoVideo",
        "label": "プロモーションビデオ",
        "enabled": true
      },
      {
        "id": "about",
        "label": "について",
        "enabled": true
      },
      {
        "id": "network",
        "label": "グローバルサービスネットワーク",
        "enabled": true
      },
      {
        "id": "team",
        "label": "上級弁護士チーム",
        "enabled": true
      },
      {
        "id": "advantages",
        "label": "私たちの利点",
        "enabled": true
      },
      {
        "id": "process",
        "label": "資金回収プロセス",
        "enabled": true
      },
      {
        "id": "testimonials",
        "label": "お客様のレビュー",
        "enabled": true
      },
      {
        "id": "risk",
        "label": "リスク警告",
        "enabled": true
      },
      {
        "id": "scamTypes",
        "label": "よくあるタイプの詐欺",
        "enabled": true
      },
      {
        "id": "faq",
        "label": "よくある質問",
        "enabled": true
      },
      {
        "id": "contact",
        "label": "お問い合わせ",
        "enabled": true
      }
    ]
  },
  "uiText": {
    "layout": {
      "24": "失敗した場合は料金はかかりません | 24時間無料評価",
      "36_14": "36 か国以上をカバー | 14 以上の管轄区域",
      "brand_full_name_en": "アジア金融犯罪捜査センター",
      "cic": "CICホームページ",
      "text_e4b8bbe5af": "メインナビゲーション",
      "text_e4bfa1e4bb": "トラストシグナル",
      "text_e5858de8b4": "免責事項",
      "text_e585a8e790": "グローバルネットワーク",
      "text_e585b7e4bd": "特定業務機関の登録情報は、正式な委託手続き中に、該当する管轄区域に応じて開示および確認することができます。",
      "text_e5bfabe980": "クイックリンク",
      "text_e68993e5bc": "ナビゲーションを開く",
      "text_e69c8de58a": "サービス範囲",
      "text_e69cace7ab": "このサイトの情報は一般的な説明のみを目的としており、正式な法的アドバイスを構成するものではありません。個々の事件の結果は証拠と管轄によって異なります。詳細を見る",
      "text_e6b395e5be": "法的声明と免責事項",
      "text_e7a7bbe58a": "モバイルナビゲーション",
      "text_e7ab8be58d": "今すぐお問い合わせください。お問い合わせページのフォームにアクセスしてください",
      "text_e7ab8be58d_2": "今すぐ相談してください",
      "text_e88194e7b3": "お問い合わせ",
      "text_e99a90e7a7": "プライバシー ポリシー"
    },
    "home": {
      "2026_3_28": "最終更新日: 2026 年 3 月 28 日",
      "text_e58685e5ae": "コンテンツ情報",
      "text_e58685e5ae_2": "コンテンツはアジア金融犯罪センターの弁護士チームによって審査されています。",
      "text_e5aea3e4bc": "プロモーションビデオ",
      "text_e69bbee8a2": "が報告されました"
    },
    "about": {
      "about_kicker_mission": "ミッション",
      "about_kicker_overview": "会社概要",
      "about_kicker_team": "チーム",
      "about_kicker_values": "値",
      "cic_2": "私たちについて · CIC",
      "cic_3": "CICについて",
      "cic_4": "CICプロフェッショナルチーム",
      "text_e4bbb7e580": "値",
      "text_e4bdbfe591": "ミッション",
      "text_e4bf9de5af": "機密保持の誓約",
      "text_e59088e8a7": "コンプライアンス",
      "text_e59ba2e998": "チーム",
      "text_e5b7a5e4bd": "仕組み",
      "text_e68891e4bb": "私たちは誰ですか",
      "text_e69cace9a1": "このページの章",
      "text_e69cace9a1_2": "このページのナビゲーション",
      "text_e69fa5e79c": "コアチームのメンバーと資格を表示",
      "text_e6b787e6bf": "奇濆瘑ガリウム股",
      "text_e88194e7b3_2": "連絡先",
      "text_e99da2e58c": "ブレッドクラム ナビゲーション",
      "text_e9a696e9a1": "ホームページ"
    },
    "process": {
      "text_e4ba86e8a7": "回復プロセスを理解する",
      "text_e69fa5e79c_2": "詳細なプロセスを表示"
    },
    "team": {
      "practice_year_unit": "年",
      "text_e4b88ae4b8": "前の投稿",
      "text_e4b88be4b8": "次へ",
      "text_e4b893e4b8": "専門分野：",
      "text_e4b893e4b8_2": "専門資格:",
      "text_e4ba86e8a7_2": "当社のサービスについて詳しく見る",
      "text_e585b3e997": "閉じる",
      "text_e58887e68d": "メンバーを切り替える",
      "text_e58cbae59d": "ブロックチェーンフォレンジック、資産追跡、デジタル証拠保存",
      "text_e59ba2e998_2": "チームメンバーの詳細",
      "text_e5a48de588": "現在のリンクをコピー",
      "text_e5b7b2e5a4": "リンクをコピーしました",
      "text_e5be8be5b8": "弁護士チーム",
      "text_e689a7e4b8": "資格:",
      "text_e689a7e4b8_2": "長年の練習:",
      "text_e69599e882": "学歴・資格",
      "text_e69caae689": "メンバー情報が見つかりません。",
      "text_e69fa5e79c_3": "プロフィールと経験の詳細を表示",
      "text_e6ada3e5bc": "正式な委託後は、該当する管轄区域およびコンプライアンス要件に従って検証できます。",
      "text_e6ada3e5bc_2": "正式委託後、コンプライアンス要件に従って検証可能",
      "text_e782b9e587": "クリックすると小窓で詳細が表示されます",
      "text_e7bb8fe9aa": "体験談・紹介",
      "text_e8afa6e683": "詳細",
      "text_e8b083e69f": "調査証拠チーム",
      "text_e8b7a8e5a2": "国境を越えた詐欺、資産回収、デジタル通貨法",
      "text_e9a284e7ba": "シニアパートナー評価の予約をする →"
    },
    "testimonials": {
      "cic_5": "カスタマーレビュー | CIC",
      "text_e4ba86e8a7_3": "サービスの利点を理解する",
      "text_e5aea2e688": "お客様のレビュー",
      "text_e5b7b2e9aa": "確認済みの顧客",
      "text_e69da5e887": "さまざまな地域の顧客からのフィードバックを依頼する",
      "text_e8bfbde59b": "回収量"
    },
    "scamTypes": {
      "cic_6": "不正行為の種類が見つかりませんでした。アジア金融犯罪センター CIC",
      "risk_level_high": "高リスク",
      "risk_level_label": "リスクレベル",
      "risk_level_low": "低リスク",
      "text_e4b8ade58d": "中リスク",
      "text_e4b8ade9a3": "中リスク",
      "text_e4bd8ee58d": "低リスク",
      "text_e58a9ee6a1": "ケース処理のヒント",
      "text_e5b7b2e5a4_2": "処理されました",
      "text_e5b7b2e5a4_3": "ケースが処理されました",
      "text_e5b8b8e8a7": "一般的な形式:",
      "text_e5b8b8e8a7_2": "一般的な詐欺の特徴",
      "text_e69caae689_2": "対応する不正タイプが見つかりません。",
      "text_e69fa5e79c_4": "詳細と回復ガイドラインを表示",
      "text_e6b689e6a1": "関係する金額の範囲:",
      "text_e6b689e6a1_2": "対象範囲",
      "text_e79bb8e585": "関連する地域サービス",
      "text_e88194e7b3_3": "お問い合わせフォーム",
      "text_e8afb4e698": "注: 上の表の「処理された症例」は、内部統計的基準を概略的に表示したものにすぎず、症例の結果に対する約束や成功率の保証を構成するものではありません。追及できるかどうか、どこまで追及できるかは、証拠と管轄権に基づいて評価されなければなりません。",
      "text_e8bf94e59b": "ホームページに戻る",
      "text_e9ab98e58d": "高リスク"
    },
    "network": {
      "cic_7": "グローバルネットワーク | CIC",
      "cic_8": "リージョンが見つかりませんでした。アジア金融犯罪捜査センター CIC",
      "network_map_filter_aria_suffix": "、Enter キーを押してフィルターします",
      "text_e4b88ae6b5": "上海・中華圏",
      "text_e4b8bbe8a6": "本社",
      "text_e5808be4bb": "代表的な都市",
      "text_e5808be58d": "コラボレーション ノード",
      "text_e580abe695": "ロンドン・ヨーロッパ",
      "text_e585a8e790_2": "グローバルネットワークの詳細",
      "text_e585a8e790_3": "グローバルサービスネットワークの概略図",
      "text_e58cbae59f": "地域サービス",
      "text_e59088e4bd": "パートナー",
      "text_e592a8e8af": "相談",
      "text_e5938de5ba": "応答メカニズム",
      "text_e59f8ee5b8": "都市リスト",
      "text_e59f8ee5b8_2": "シティノード",
      "text_e5a48de588_2": "現在のビューのリンクをコピー",
      "text_e5a49ae580": "トロント",
      "text_e5a4a7e58d": "地域と代表都市",
      "text_e68289e5b0": "シドニー",
      "text_e696b0e58a": "シンガポール・本社",
      "text_e696b0e58a_2": "シンガポール",
      "text_e69c8de58a_2": "サービスネットワーク",
      "text_e69caae689_3": "対応する地域ページが見つかりませんでした。",
      "text_e69cace9a1_3": "このページのブロック",
      "text_e69d9ce68b": "ドバイ",
      "text_e69db1e4ba": "東京",
      "text_e6b395e898": "フランクフルト",
      "text_e79c8be5ae": "完全なグローバル ネットワークを見る",
      "text_e7ab8be58d_3": "今すぐ相談してください",
      "text_e7b490e7b4": "ニューヨーク・アメリカ",
      "text_e7bd91e7bb": "ネットワークの利点",
      "text_e8a686e79b": "カバレッジ ノード",
      "text_e8bfaae68b": "ドバイ・アフリカ中東",
      "text_e8bfaae68b_2": "ドバイ",
      "text_e9878de782": "主要都市",
      "text_e9a699e6b8": "香港・アジア太平洋",
      "text_e9bb9ee693": "領域ラベルをクリックすると、上部のマップと下部のノードが同時に強調表示されます。",
      "text_e9bb9ee693_2": "ラベルをクリックすると、対応する都市が表示されます"
    },
    "contact": {
      "24_2": "事前コメントには 24 時間以内に返信します",
      "cic_9": "* が付いているフィールドは必須です。まず基本的な事件の事実、転送情報、証拠の状況を提出すると、CIC チームが事件の種類に基づいて予備評価を提供します。",
      "contact_method_email": "メール",
      "contact_methods_eyebrow": "お問い合わせ",
      "text_e4bfa1e4bb_2": "信頼とコンプライアンス",
      "text_e58d94e58a": "転送、チャット、プラットフォームの証拠の整理を支援します。",
      "text_e58f91e980": "メールを送信",
      "text_e590abe58c": "市外局番を含む（オプション）",
      "text_e59ca8e7ba": "オンライン相談",
      "text_e5a48de588_3": "このページのリンクをコピーします",
      "text_e5a793e590": "名前 *",
      "text_e5aea2e688_2": "カスタマーサービス",
      "text_e5b7b2e694": "はあなたの相談情報を受け取り、フォローアップ連絡ページを開きます。",
      "text_e5b7b2e694_2": "お問い合わせ情報を受け取りましたので、できるだけ早くご連絡いたします。",
      "text_e682a8e79a": "あなたの役職",
      "text_e68f90e4ba": "送信に失敗しました。後でもう一度試してください。",
      "text_e68f90e4ba_2": "送信中...",
      "text_e68f90e4ba_3": "問い合わせを送信",
      "text_e6a188e4bb": "ケースの種類",
      "text_e6a188e683": "ケースの説明 *",
      "text_e794b5e5ad": "メール *",
      "text_e88194e7b3_4": "連絡先番号",
      "text_e881afe7b5": "連絡先情報",
      "text_e8afb7e7ae": "送金時間、金額、プラットフォーム名、保存された証拠を簡単に説明してください",
      "text_e8afb7e980": "選択してください（任意）",
      "text_e8b387e696": "情報は暗号化され、機密として厳重に保管されます",
      "text_e8bea6e585": "オフィスアドレス",
      "whatsapp": "電話/WhatsApp"
    },
    "admin": {
      "0": "0 条",
      "admin_browser_title": "Admin | CIC",
      "admin_event_click_button": "ClickButton",
      "admin_event_complete_registration": "CompleteRegistration",
      "admin_event_contact": "Contact",
      "admin_event_page_view": "PageView",
      "admin_lead_ip": "IP",
      "admin_leads_count_unit": "条",
      "admin_product_name": "CIC Admin",
      "admin_tiktok_pixel_id": "TikTok Pixel ID",
      "customer_service": " 打开在线客服时上报。",
      "customer_service_kefu_code": "指定客服",
      "customer_service_script_url": "客服系统地址",
      "contact_whatsapp_tiktok_pixel": "管理联系页展示、在线客服、WhatsApp 跳转和 TikTok Pixel。",
      "description": " 右下角浮动“立即咨询”点击时上报，参数 description 为当前路径。",
      "post_api_contact_leads": " 联系页表单 POST /api/contact-leads 成功后上报。",
      "post_tiktok_completeregistration": "表单会先 POST 到后端保存咨询记录，成功后触发 TikTok CompleteRegistration；跳转链接留空则只显示成功提示。",
      "text_e2809420e5": " 像素加载后自动上报。",
      "text_e4b88ae4b8_2": "上一页",
      "text_e4b88be4b8_2": "下一页",
      "text_e4bf9de5ad": "保存失败",
      "text_e4bf9de5ad_2": "保存中...",
      "text_e4bf9de5ad_3": "保存配置",
      "text_e588b7e696": "刷新数据",
      "text_e5908ee58f": "后台管理",
      "text_e5908ee58f_2": "后台数据读取失败",
      "text_e5908ee58f_3": "后台菜单",
      "text_e592a8e8af_2": "咨询记录",
      "text_e59cb0e59d": "地址",
      "text_e5af86e7a0": "密码",
      "text_e69a82e697": "暂无咨询记录。",
      "text_e69caae5a1": "未填写姓名",
      "text_e794a8e688": "用户名",
      "text_e794b5e8af": "电话",
      "text_e799bbe5bd": "登录成功",
      "text_e799bbe5bd_2": "登录失败",
      "text_e799bbe5bd_3": "登录中...",
      "text_e799bbe5bd_4": "登录",
      "text_e7acac": "第",
      "text_e7b1bbe59e": "类型",
      "text_e88194e7b3_5": "联系与转化配置",
      "text_e88194e7b3_6": "联系配置",
      "text_e88194e7b3_7": "联系页面配置",
      "text_e8a1a8e58d": "表单提交后的跳转链接",
      "text_e98080e587": "退出登录",
      "text_e982aee7ae": "邮箱",
      "text_e9858de7bd": "配置已保存",
      "text_e9a1b5": "页",
      "tiktok": "TikTok 监测说明",
      "tiktok_url_pixel_helper_all": "测试事件时，在 TikTok 后台填写站点 URL 并点击“打开网站”；上报可能延迟数分钟，以 Pixel Helper 的 All events 或 TikTok 后台统计为准。",
      "whatsapp_2": "WhatsApp 或其他后续沟通链接；留空则不跳转",
      "xxxxxxxx_xxxx_xxxx_xxxx_xxxxxxxxxxxx": "例如：xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx"
    },
    "api": {
      "api_contact_email_invalid": "メールの形式が正しくありません",
      "api_contact_required": "お名前、メールアドレス、ケースの説明を入力してください"
    },
    "system": {
      "cic_10": "ページが見つかりません |アジア金融犯罪捜査センター CIC",
      "text_e682a8e8ae": "アクセスしたページは存在しないか、移動されました。"
    }
  }
};

export const defaultSiteContent = siteContent;
export default siteContent;
